import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Component to handle errors in the game with retry options
 */
const ErrorHandler = ({ error, resetError }) => {
  const navigate = useNavigate();

  // Function to determine if the error is related to multiple choice questions
  const isMultipleChoiceError = (errorMsg) => {
    return errorMsg && (
      errorMsg.includes('選択肢') || 
      errorMsg.includes('次の手がかり') ||
      errorMsg.includes('無効')
    );
  };

  const handleRetry = () => {
    // Clear the error and reload the current page
    if (resetError) {
      resetError();
    } else {
      window.location.reload();
    }
  };

  const handleGoHome = () => {
    // Navigate back to the home page
    navigate('/home');
  };

  // Determine error message to show
  const errorMessage = error || "この手がかりにはエラーがあります。あとでもう一度お試しください。";
  const isChoiceError = isMultipleChoiceError(error);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-md mx-auto">
        <h2 className="text-xl font-bold text-red-600 mb-4">エラーが発生しました</h2>
        <p className="text-gray-700 mb-6">
          {errorMessage}
        </p>
        <div className="flex flex-col space-y-2">
          <button
            onClick={handleGoHome}
            className="w-full py-2 px-4 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
          >
            ホームに戻る
          </button>
          <button
            onClick={handleRetry}
            className="w-full py-2 px-4 bg-teal-500 text-white rounded hover:bg-teal-600 transition-colors"
          >
            もう一度試す
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorHandler; 